define(["npm:jquery@3.3.1/dist/jquery.js"], function(main) {
  return main;
});